/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

export interface DMapTileMappingInternal {
	scale: number;
	x: number;
	y: number;
}
